import { ToolsService } from '../../../services/tools.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-bespoke-size-form',
    templateUrl: './bespoke-size-form.component.html',
    styleUrls: ['./bespoke-size-form.component.scss']
})
export class BespokeSizeFormComponent implements OnInit {
    @Input() product;
    @Input() subTypes;
    @Input() restrictions;
    @Input() allowRandom = true;
    @Input() costsSQM;
    @Input() heightValidation;
    @Output() recalculate = new EventEmitter();
    @Output() setSubStep = new EventEmitter();
    @Output() clearSubStep = new EventEmitter();
    @Output() validHeight = new EventEmitter();
    @Output() validQuantity = new EventEmitter();

    div = 0;
    showQuantityDropdown = false;
    previousLengthRandom = 0;
    productQuantitySelected: any;

    constructor(
        private toolsService: ToolsService,
    ) {
    }

    ngOnChanges(): void {

        this.productQuantitySelected = this.product.sellUnit;

    }

    ngOnInit(): void {

        // this.product.purchaseUnit = this.product.sellUnit;
        if (this.product.type.id === 'steps') {
            this.product.sellUnit = { id: 'P', name: 'Pieces' };
        }

        if (this.product.type.defaultIsRandom) {
            this.product.lengthRandom = true;
            this.product.length = 1000;
            this.product.length = this.restrictions.length.max;
            this.previousLengthRandom = this.product.length;
        }
        if (this.product.type.id === 'coping') {
            this.product.copingLengthMeasure = 'M';
        }

        if (this.restrictions.width.min) {
            this.product.width = this.restrictions.width.min;
        }

        if (this.restrictions.length.min) {
            this.product.length = this.restrictions.length.min;
        }

        if ((this.product.type && this.product.type.id !== 'coping') || this.product.type.id === 'coping') {
            this.product.quantity = 1;
        }
    }

    toggleCopingLengthMeasure() {
        if (this.product.copingLengthMeasure === 'M') {
            this.product.copingLengthMeasure = 'I';
        } else {
            this.product.copingLengthMeasure = 'M';
        }
        this.updateTotalLength();
    }

    setSellUnit(v) {
        this.product.sellUnit = v;
        this.calcBespokeCost();
    }

    lengthRandom() {
        if (!this.product.lengthRandom) {
            this.product.lengthRandom = true;
            this.product.length = this.product.type.randomLength;
            this.product.length = this.restrictions.length.max;

            // if (this.product.copingLengthMeasure === 'M') {
            //     this.product.quantity = Math.ceil((+this.product.totalLength * 1000) / this.product.length);
            // } else {
            //     this.product.quantity = Math.ceil((+this.product.totalLength * 25.4) / this.product.length);
            // }

        } else {
            this.product.lengthRandom = false;
            this.product.widthRandom = false;
            this.product.length = this.previousLengthRandom;
        }
        if (this.product.type.id === 'setts' || this.product.type.id === 'paving') {
            if (this.product.lengthRandom) {
                this.product.sellUnit = { id: 'PSM', name: 'Square metre' };
                this.product.type.allowPieces = 0;
            } else {
                this.product.type.allowPieces = 1;
            }
        }
        this.recalculate.emit(true);
    }

    widthRandom() {
        if (!this.product.widthRandom) {
            this.product.widthRandom = true;
            this.product.width = this.product.type.randomWidth;
        } else {
            this.product.widthRandom = false;
        }
        if (this.product.type.id === 'setts' || this.product.type.id === 'paving') {
            if (this.product.widthRandom) {
                this.product.sellUnit = { id: 'PSM', name: 'Square metre' };
                this.product.type.allowPieces = 0;
            } else {
                this.product.type.allowPieces = 1;
            }
        }

        this.recalculate.emit(true);

    }

    updateLength() {
        this.previousLengthRandom = this.product.length;
        if (this.product.type.id === 'coping') {
            if (this.product.totalLength > 0 && !this.product.lengthRandom) {
                // if (this.product.copingLengthMeasure === 'M') {
                //     this.product.quantity = Math.ceil((+this.product.totalLength * 1000) / this.product.length);
                // } else {
                //     this.product.quantity = Math.ceil((+this.product.totalLength * 25.4) / this.product.length);
                // }
            } else {
                this.product.totalLength = (this.product.length) * this.product.quantity;
            }

            if ((this.product.type && this.product.type.id !== 'coping') || this.product.type.id === 'coping') {
                this.validQuantity.emit(false);
            }
        }
        this.calcBespokeCost();
    }

    updateTotalLength() {
        let totalLengthMM = 0;
        if (this.product.totalLength > 0) {
            if (this.product.lengthRandom) {
                if (this.product.copingLengthMeasure === 'M') {
                    totalLengthMM = this.product.totalLength * 1000;
                } else {
                    totalLengthMM = this.product.totalLength * 25.4;
                }
                const totalPieces = totalLengthMM / 1000;
                this.product.length = this.product.restrictions.length.max;
                this.product.quantity = totalPieces;
            } else {
                this.product.quantity = (this.product.totalLength * 10) / this.product.length;

                if (this.product.copingLengthMeasure === 'M') {
                    this.product.quantity = (+this.product.totalLength * 1000) / this.product.length;
                } else {
                    this.product.quantity = (+this.product.totalLength * 25.4) / this.product.length;
                }

            }
        }

        this.calcBespokeCost();
    }


    calcBespokeCost() {
        this.getLeadTime();
        this.recalculate.emit();
    }

    triggerSetSubStep(step) {
        this.setSubStep.emit(step);
    }
    timeoutTriggerSetSubStep(step) {
        this.setSubStep.emit(step);
        // setTimeout(() => {
        //     this.triggerClearSubStep()
        // }, 3000)
    }

    triggerClearSubStep() {
        this.clearSubStep.emit();
    }

    calcNoSteps(maxLength) {
        this.div = Math.ceil(this.product.length / maxLength);
        const noSteps = (this.product.length / this.div).toFixed(2);
        return noSteps;
    }
    validateHeight() {
        let costType = 'random';
        if ((this.product.lengthRandom && !this.product.widthRandom) || (this.product.widthRandom && !this.product.lengthRandom)) {
            costType = 'setWidthRandom';
        }
        if (this.product.lengthRandom && this.product.widthRandom) {
            costType = 'random';
        }
        if (!this.product.lengthRandom && !this.product.widthRandom) {
            costType = 'setWidthSetLength';
        }

        if (!this.costsSQM) {
            if (+this.product.height < +this.restrictions.height.min || +this.product.height > +this.restrictions.height.max) {
                this.heightValidation.min = this.restrictions.height.min;
                this.heightValidation.max = this.restrictions.height.max;
                this.heightValidation.valid = false;
                this.validHeight.emit(false);
                return false;
            } else {
                this.heightValidation.valid = true;
                this.validHeight.emit(true);
                return true;
            }
        }

        if (+this.product.height < +this.restrictions.height.min || +this.product.height > +this.restrictions.height.max) {
            this.heightValidation.min = this.restrictions.height.min;
            this.heightValidation.max = this.restrictions.height.max;
            this.heightValidation.valid = false;
            this.validHeight.emit(false);
            return false;
        } else {
            this.heightValidation.valid = true;
            this.validHeight.emit(true);
            return true;
        }

        const minCosts = this.costsSQM[costType][0];
        const maxCosts = this.costsSQM[costType][this.costsSQM[costType].length - 1];


        if (maxCosts) {
            if (+this.product.height < +minCosts.minThickness || +this.product.height > +maxCosts.maxThickness) {
                this.heightValidation.min = minCosts.minThickness;
                this.heightValidation.max = maxCosts.maxThickness;
                this.heightValidation.valid = false;
                this.validHeight.emit(false);
                return false;
            }

        }
        this.validHeight.emit(true);
        this.heightValidation.valid = true;
        // hack to speed up the price refresh
        // setTimeout(() => { }, 10)
        return true;
    }


    getLeadTime() {
        let days = 15;
        this.product.leadtimes.forEach(e => {
            if (this.product.quantity >= +e.minUnit && this.product.quantity <= +e.maxUnit) {
                days = e.days;
                this.product.leadtime = e.days;
            }
        });
        this.product.estDeliveryDate = this.toolsService.addDaysToDate(new Date(), days, true);
    }

}
